import React, { useEffect, useState } from "react";
import { Table } from "reactstrap";

const ReuseableTable = ({ columns, data, keyMap, renderActions, renderCell, emptyMessage = "No records found" }) => {
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <Table className="align-items-center table-flush mt-3" responsive>
      <thead>
        <tr>
          {columns?.map((column, index) => (
            <th
              scope="col"
              key={index}
              className="custom-table-heading custom-heading whitespace-nowrap"
              style={{ fontSize: isSmallScreen ? "13px" : "20px" }}
            >
              {column}
            </th>
          ))}
          {renderActions && (
            <th
              scope="col"
              className="custom-table-heading custom-heading"
              style={{ fontSize: isSmallScreen ? "13px" : "20px" }}
            >
              Action
            </th>
          )}
        </tr>
      </thead>
      <tbody className="custom-table-body mt-3">
        {data?.length > 0 ? (
          data?.map((row, rowIndex) => (
            <tr key={rowIndex}>
              {columns?.map((column, colIndex) => (
                <td key={colIndex} className={`custom-table-text`}>
                  {renderCell ? renderCell(column, row) ?? (row[keyMap[column]] || "") : row[keyMap[column]] || ""}
                </td>
              ))}
              {renderActions && (
                <td className="card-subtitle">
                  {renderActions(row, rowIndex)}
                </td>
              )}
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan={columns.length + (renderActions ? 1 : 0)} className="text-center text-muted py-4 font-weight-500">
              {emptyMessage}
            </td>
          </tr>
        )}
      </tbody>
    </Table>
  );
};

export default ReuseableTable;
